import { AddIntegrationLink } from '../../../components/AddIntegrationLink';

export const TasksOverviewIntegrations = () => {
  return (
    <div className="space-y-2">
      <div className="space-y-0.5">
        <h2 className="font-medium text-zinc-800">Integrations</h2>
        <p className="text-sm text-zinc-600">
          Improve compliance monitoring and receive timely alerts
        </p>
      </div>

      <AddIntegrationLink />
    </div>
  );
};
